import { Link } from "react-router-dom";
import { comicCategories } from "@/mocks/comics";
import { contactItems, siteNav } from "@/mocks/site";

const socials = [
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-bilibili-fill", label: "哔哩哔哩" },
  { icon: "ri-mail-fill", label: "邮箱" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-primary-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-sparkling-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl text-background-50">妖精漫画</span>
            </div>
            <p className="text-sm leading-relaxed text-primary-200">
              专注妖精题材漫画作品与资讯的内容平台，陪你在奇幻森林里，找到下一部心动的故事。
            </p>
            <div className="flex items-center gap-3">
              {socials.map((s) => (
                <button
                  key={s.label}
                  type="button"
                  aria-label={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 text-primary-100 transition-colors hover:bg-secondary-500 hover:text-background-50 cursor-pointer"
                >
                  <i className={`${s.icon} text-lg`}></i>
                </button>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <h4 className="text-sm font-medium text-background-50">
              <a href="/#">网站导航</a>
            </h4>
            <ul className="flex flex-col gap-2 text-sm">
              {siteNav.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-primary-200 transition-colors hover:text-background-50 cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col gap-3">
            <h4 className="text-sm font-medium text-background-50">
              <a href="/#">热门分类</a>
            </h4>
            <ul className="flex flex-col gap-2 text-sm">
              {comicCategories.map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={`/category?cat=${encodeURIComponent(cat.name)}`}
                    className="text-primary-200 transition-colors hover:text-background-50 cursor-pointer"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col gap-3">
            <h4 className="text-sm font-medium text-background-50">
              <a href="/#">联系我们</a>
            </h4>
            <ul className="flex flex-col gap-3 text-sm">
              {contactItems.map((item) => (
                <li key={item.label} className="flex items-start gap-2">
                  <i className={`${item.icon} mt-0.5 text-secondary-400`}></i>
                  <span className="text-primary-200">
                    {item.label}：{item.value}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-primary-800 pt-6 text-xs text-primary-300 sm:flex-row">
          <p>© 2026 妖精漫画 · 本站内容为演示数据，仅供浏览体验。</p>
          <p className="flex items-center gap-2">
            <i className="ri-leaf-line"></i>
            用故事，守护每一片小小的森林
          </p>
        </div>
      </div>
    </footer>
  );
}